<template>
    <div ref="sentinelRef" />
    <Transition
        v-if="isMounted"
        :enterFromClass="$style.fade_enter_from"
        :enterActiveClass="$style.fade_enter_active"
        :leaveActiveClass="$style.fade_leave_active"
        :leaveToClass="$style.fade_leave_to"
        appear
    >
        <div
            v-if="isBannerVisible"
            :class="$style.banner"
        >
            <div :class="$style.backdrop" />
            <button
                v-if="isAdBlockVisible && isStickyMode"
                :class="$style.close_button"
                data-interface-target="close-sticky-desktop-banner"
                @click="onClose"
            >
                <Icon
                    name="close"
                    :class="$style.close_icon"
                />
            </button>
            <AdBlock
                type="sticky_mobile_non_game_page"
                @update:visible="onAdVisibilityChanged"
            />
        </div>
    </Transition>
</template>

<script setup lang="ts">
import { useIntersectionObserver } from '@vueuse/core'

import { ref } from 'vue'

import AdBlock from '@/components_new/AdBlock.vue'
import Icon from '@/components_new/Icon/Icon.vue'
import { useLoggerStore } from '@/store/logger'
import { useIsMounted } from '@/utils/vue-hooks/use-is-mounted'

const loggerStore = useLoggerStore()
const isMounted = useIsMounted()

const isAdBlockVisible = ref(false)
const isBannerVisible = ref(true)
const isStickyMode = ref(true)

const sentinelRef = ref<HTMLDivElement>()

function onClose() {
    loggerStore.logEvent({
        event: 'custom_event',
        eventName: 'ad_close',
        adPlacement: 'sticky_mobile',
    })
    isBannerVisible.value = false
}

function onAdVisibilityChanged(isVisible: boolean) {
    isAdBlockVisible.value = isVisible
}

useIntersectionObserver(sentinelRef, (entries) => {
    isStickyMode.value = !entries[0].isIntersecting
})
</script>

<style module>
.banner {
    position: sticky;
    bottom: 0;
    margin-left: calc(-1 * var(--global-padding-horizontal) - env(safe-area-inset-left));
    margin-right: calc(-1 * var(--global-padding-horizontal) - env(safe-area-inset-left));
}

.close_button {
    position: absolute;
    top: -30px;
    right: 0;
    padding: 6px;
    background: transparent;
}

.close_icon {
    width: 24px;
    height: 24px;
    background: rgba(0, 0, 0, 0.5);
    backdrop-filter: blur(20px);
    border-radius: 4px 4px 0 0;
}

.backdrop {
    position: absolute;
    top: 0;
    bottom: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.5);
    backdrop-filter: blur(40px);
}

.fade_enter_active,
.fade_leave_active {
    transition: all 0.8s ease;
}

.fade_enter_from,
.fade_leave_to {
    transform: translateY(300px);
}
</style>
